package com.dignicate.web.data.markdown.model

import com.dignicate.web.domain.Language

data class ParsedMarkdownDocument(
    val slug: String,
    val lang: Language,
    val metadata: Map<String, String>,
    val title: String?,              // 最初の # 見出しを採用。無ければ null
    val blocks: List<MarkdownBlock>, // 簡易パース結果
    val raw: String
)
